import React, { useMemo, useState, useContext, useEffect } from 'react';
import {
  Box,
  Stack,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  IconButton,
  Tooltip
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import axios from "../../api/axios";
import { useNavigate } from 'react-router-dom';
import GeneralContext from "../GeneralContext/GeneralContext";

import CustomAccordion from "../GeneralComponents/CustomAccordion";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import { usePeriodos } from '../utils/utilsRut';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';


import ModalStandardCancel from "../GeneralComponents/ModalStandardCancel";
import {ROL_ADMIN, ROL_OP_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL} from "../../Constants/Constants";


interface DescuentoPeriodoCardProps {
  data: {
    id: number,
    periodo: string;
    id_operador: number;
    d_total_n: number;
    valor_adjudicado_sin_iva: number;
    valor_adjudicado_con_iva: number;
    descuento_especifico ?: number;
    descuento_especifico_descripcion ?: string;
    descuento_especifico_descripcion_full ?: string;
    abono ?: number;
    abono_descripcion ?: string;
    abono_descripcion_full ?: string;
    d_total_n_menos_1: number;
    valor_mensual_a_facturar_con_iva: number;
    codigo?: string;
    nombre_validador?: string;
  };
  defaultExpanded?: boolean;
  editAccess?: boolean;
}

const DescuentoPeriodoCardV2: React.FC<DescuentoPeriodoCardProps> = ({ data, fetch, defaultExpanded = true, editAccess=false }) => {

  console.log(data)

  const {  includeRol } =  useContext(GeneralContext);
  const [originalEtiqueta, setOriginalEtiqueta] = useState(data.descuento_especifico_descripcion?.trim() || "Descuento Específico");
  const [originalDescuento, setOriginalDescuento] = useState(data.descuento_especifico ?? 0);
  const [originalDetalle, setOriginalDetalle] = useState(data.descuento_especifico_descripcion_full ?? '');

  const [labelEspecial, setLabelEspecial] = useState(originalEtiqueta);
  const [especial, setEspecial] = useState(originalDescuento);
  const [detalleEspecifico, setDetalleEspecifico] = useState(originalDetalle);
  const [loading, setLoading] = useState(false);


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {setOpen(true);}
  const handleClose = () =>{ setOpen(false);}


  const [originalEtiquetaAbono, setOriginalEtiquetaAbono] = useState(data.abono_descripcion?.trim() || "Abono");
  const [originalAbono, setOriginalAbono] = useState(data.abono ?? 0);
  const [originalDetalleAbono, setOriginalDetalleAbono] = useState(data.abono_descripcion_full ?? '');
  console.log(data.abono);
  console.log(originalAbono)
  const [labelEspecialAbono, setLabelEspecialAbono] = useState(originalEtiquetaAbono);
  const [especialAbono, setEspecialAbono] = useState(originalAbono);
  const [detalleEspecificoAbono, setDetalleEspecificoAbono] = useState(originalDetalleAbono);

  const [type, setType] = useState(true);

    const {
    periodoActual,
    periodoAnterior,
    periodoSiguiente,
    mesAnteriorNombre,
    mesActualNombre,
    mesSiguienteNombre
  } = usePeriodos(data.periodo);

  const [isEditing, setIsEditing] = useState( 
    !editAccess ? false :
    data.codigo !== "-" 
      ? false
      : !(
          data.descuento_especifico_descripcion ||
          data.descuento_especifico ||
          data.descuento_especifico_descripcion_full
        )
  );

  const [isEditingAbono, setIsEditingAbono] = useState( 
    !editAccess ? false :
    data.codigo !== "-" 
      ? false
      : !(
          data.abono_descripcion ||
          data.abono ||
          data.abono_descripcion_full
        )
  );
  const [expandedEspecial, setExpandedEspecial] = useState(defaultExpanded);
  const [expandedEspecialAbono, setExpandedEspecialAbono] = useState(defaultExpanded);
  const navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState(false);

  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 2,
    }).format(value);

  const acceptPrefacture = () => {
  setLoading(true);   
  axios
      .acceptPrefactura(data.id)
      .then((response) => {
        fetch(data.periodo);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });

  
}


  const handleToggleEdit = async () => {
    if (isEditing) {
      if (
        labelEspecial !== originalEtiqueta ||
        especial !== originalDescuento ||
        detalleEspecifico !== originalDetalle
      ) {
        axios
      .updateDescuentoPrefactura(data.id_operador, data.periodo+'-01', data.version, {'descuento_especifico':especial, 'descuento_especifico_descripcion': labelEspecial, 'descuento_especifico_descripcion_full': detalleEspecifico})
      .then((response) => {
        setOriginalEtiqueta(labelEspecial?.trim() || "Descuento Específico");
        setOriginalDescuento(especial);
        setOriginalDetalle(detalleEspecifico);
      })
      .catch((error) => {
          setLabelEspecial(originalEtiqueta);
          setEspecial(originalDescuento);
          setDetalleEspecifico(originalDetalle);

      })
      .finally(() => {
      });
      }
    }
    setIsEditing(prev => !prev);
  };

    const handleToggleEditAbono = async () => {
    if (isEditing) {
      if (
        labelEspecialAbono !== originalEtiquetaAbono ||
        especialAbono !== originalAbono ||
        detalleEspecificoAbono !== originalDetalleAbono
      ) {
        axios
      .updateAbonosPrefactura(data.id_operador, data.periodo+'-01', data.version, {'abono':especialAbono, 'abono_descripcion': labelEspecialAbono, 'abono_descripcion_full': detalleEspecificoAbono})
      .then((response) => {
        setOriginalEtiquetaAbono(labelEspecialAbono?.trim() || "Abono");
        setOriginalAbono(especialAbono);
        setOriginalDetalleAbono(detalleEspecificoAbono);
      })
      .catch((error) => {
          setLabelEspecialAbono(originalEtiquetaAbono);
          setEspecialAbono(originalAbono);
          setDetalleEspecificoAbono(originalDetalleAbono);

      })
      .finally(() => {
      });
      }
    }
    setIsEditingAbono(prev => !prev);
  };



    const getPreCode = async (query, periodo) => {
    setLoadingButton(true);
    axios
      .getCode(query)
      .then((response) => {
          fetch(periodo)
      })
      .catch((error) => {})
      .finally(() => {


        setLoadingButton(false);
      });


 
}

 useEffect(() => {
  if (data.descuento_especifico !== undefined) {
    setOriginalDescuento(data.descuento_especifico);
    setEspecial(data.descuento_especifico);
  }
  if (data.descuento_especifico_descripcion) {
    const trimmed = data.descuento_especifico_descripcion.trim();
    setOriginalEtiqueta(trimmed);
    setLabelEspecial(trimmed);
  }
  if (data.descuento_especifico_descripcion_full) {
    setOriginalDetalle(data.descuento_especifico_descripcion_full);
    setDetalleEspecifico(data.descuento_especifico_descripcion_full);
  }
}, [
  data.descuento_especifico,
  data.descuento_especifico_descripcion,
  data.descuento_especifico_descripcion_full
]);

  useEffect(() => {
  if (data.abono !== undefined) {
    setOriginalAbono(data.abono);
    setEspecialAbono(data.abono);
  }
  if (data.abono_descripcion) {
    setOriginalEtiquetaAbono(data.abono_descripcion.trim());
    setLabelEspecialAbono(data.abono_descripcion.trim());
  }
  if (data.abono_descripcion_full) {
    setOriginalDetalleAbono(data.abono_descripcion_full);
    setDetalleEspecificoAbono(data.abono_descripcion_full);
  }
}, [data.abono, data.abono_descripcion, data.abono_descripcion_full]);

  const accordionSx = { p: 0, m:0, bgcolor: 'transparent', boxShadow: 'none', '&:before': { display: 'none' } };
  const summarySx = { p: "8px 8px 8px 4px", flexDirection: 'row', alignItems: 'center', ml: 1, mr:1 ,
    '& .MuiAccordionSummary-expandIconWrapper': { p: 0, mr: 1 },
    '& .MuiAccordionSummary-content': { m: 0 }, borderRadius: 2, minHeight: "3px"};

  const ExpandButton = ({ expanded, onClick }: { expanded: boolean; onClick: () => void }) => (
    <IconButton onClick={e => { e.stopPropagation(); onClick(); }} size="small" sx={{ p: 0, mr: 1 }}>
      <ExpandMoreIcon sx={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />
    </IconButton>
  );

  return (
  <>
    <Grid container spacing={1} alignItems="stretch" sx={{ pt: 0 }}>
      <Grid size={12} sx={{mb: 0}}>
        <Typography variant="h6" sx={{padding: 0, pt: 0, fontFamily: '"Roboto", "Helvetica"', textAlign: "center" }}>
                      <b>TOTALES A FACTURAR {mesActualNombre} ({data.periodo})</b>
            </Typography>
      </Grid>
      <Grid size={12}>
        <Divider color="#000"/>
      </Grid> 
      <Grid size={12}>
<Box sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 2 }}>
          
          <Typography
            variant="body2"
            sx={{  flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            Valor total adjudicado con IVA (proporcional): 
          </Typography>

          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {formatCurrency(data.valor_mensual_a_facturar_con_iva)}
          </Typography>
        </Box>
      </Grid> 

  <Grid size={12}>
        <CustomAccordion
            descripcion="Dcto. total (dcto. 1 + dcto. 2):"
            monto={formatCurrency(data.d_total_n_menos_1 + data.d_total_n_menos_2)}
            contenido={{
              normal: "Este monto corresponde al total del descuento 1 + el descuento 2 y",
              bold: "será descontado ahora."
            }}
          />

      </Grid>


      {(includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_ADMIN]) || especial != 0) &&
       (<Grid size={12}>
                    {/* Descuento Específico */}
            <Accordion disableGutters elevation={0} expanded={expandedEspecial} square sx={{accordionSx}}>
              <AccordionSummary sx={{...summarySx, backgroundColor: "#D8431533"}}>
                <ExpandButton expanded={expandedEspecial} onClick={() => setExpandedEspecial(prev => !prev)} />
                <Stack direction="row" spacing={1} sx={{ flexGrow: 1, alignItems: 'center', overflow: 'hidden' }}>
                  {isEditing ? (
                    
                    <Grid container sx={{ flexGrow: 1, alignItems: 'center', overflow: 'hidden', mr: 2 }} >
                      <Grid size={7}>
                      <TextField size="small" placeholder="Etiqueta" value={labelEspecial} sx={{fontSize: "8px"}} onChange={e => setLabelEspecial(e.target.value)} sx={{ flex: 1, minWidth: 0, p: 0,  '& .MuiInputBase-input': {padding: '4px 8px'} }} />
                      
                      </Grid>
                      <Grid size={5} sx={{px: 1}}>
                      <TextField size="small" type="number" placeholder="Descuento" value={especial} onChange={e => setEspecial(+e.target.value)} sx={{ width: 120, flexShrink: 0,  '& .MuiInputBase-input': {padding: '4px 8px'} }} />
                      </Grid>
                    </Grid>
                   
                  ) : (
                    <Typography variant="body2" sx={{ color: '#D84315', flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      <b>{labelEspecial}: {formatCurrency(especial)}</b>
                    </Typography>
                  )}
                </Stack> 
                {editAccess ? 
                <IconButton disabled={data.codigo !== "-"} size="small" onClick={handleToggleEdit} sx={{ p: 0, ml: 1 }}>
                  {isEditing ? <LockOpenIcon fontSize="small" /> : <LockIcon fontSize="small" />}
                </IconButton> : null }
              </AccordionSummary>
              {expandedEspecial && (
                <AccordionDetails sx={{ py: 1 }}>
                  {editAccess ? 
                  <TextField disabled={!isEditing} fullWidth multiline minRows={2} variant="outlined" size="small" placeholder="Detalle del descuento acordado" value={detalleEspecifico} onChange={e => setDetalleEspecifico(e.target.value)} sx={{ m: 0 }} />
                  : 
                  <Typography variant="body2" color="textSecondary" sx={{ px: 2, py: 1 }}>
                   {detalleEspecifico ? detalleEspecifico : '' }
                  </Typography>}
                </AccordionDetails>
              )}
            </Accordion>


      </Grid>)
      }

      {(includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_ADMIN]) || especialAbono != 0) &&
       (<Grid size={12}>
                    {/* Abono Específico */}
            <Accordion disableGutters elevation={0} expanded={expandedEspecialAbono} square sx={accordionSx}>
              <AccordionSummary sx={{...summarySx, backgroundColor: "#C8E6C9"}}>
                <ExpandButton expanded={expandedEspecialAbono} onClick={() => setExpandedEspecialAbono(prev => !prev)} />
                <Stack direction="row" spacing={1} sx={{ flexGrow: 1, alignItems: 'center', overflow: 'hidden' }}>
                  {isEditingAbono ? (
                    <Grid container sx={{ flexGrow: 1, alignItems: 'center', overflow: 'hidden', mr: 2 }} >
                      <Grid size={7}>
                        <TextField size="small" placeholder="Etiqueta" value={labelEspecialAbono} onChange={e => setLabelEspecialAbono(e.target.value)} sx={{ flex: 1, minWidth: 0, p: 0,  '& .MuiInputBase-input': {padding: '4px 8px'} }} />
                      </Grid>
                      
                      <Grid size={5} sx={{px: 1}}>
                        <TextField size="small" type="number" placeholder="Abono" value={especialAbono} onChange={e => setEspecialAbono(+e.target.value)} sx={{ width: 120, flexShrink: 0,  '& .MuiInputBase-input': {padding: '4px 8px'} }} />
                      </Grid>
                    </Grid>
                  ) : (
                    <Typography variant="body2" sx={{ color: '#D84315', flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      <b>{labelEspecialAbono}: {formatCurrency(especialAbono)}</b>
                    </Typography>
                  )}
                </Stack> 
                {editAccess ? 
                <IconButton disabled={data.codigo !== "-"} size="small" onClick={handleToggleEditAbono} sx={{ p: 0, ml: 1 }}>
                  {isEditingAbono ? <LockOpenIcon fontSize="small" /> : <LockIcon fontSize="small" />}
                </IconButton> : null }
              </AccordionSummary>
              {expandedEspecialAbono && (
                <AccordionDetails sx={{ py: 1 }}>
                  {editAccess ? 
                  <TextField disabled={!isEditingAbono} fullWidth multiline minRows={2} variant="outlined" size="small" placeholder="Detalle del abono acordado" value={detalleEspecificoAbono} onChange={e => setDetalleEspecificoAbono(e.target.value)} sx={{ m: 0 }} />
                  : 
                  <Typography variant="body2" color="textSecondary" sx={{ px: 2, py: 1 }}>
                   {detalleEspecificoAbono ? detalleEspecificoAbono : '' }
                  </Typography>}
                </AccordionDetails>
              )}
            </Accordion>

      </Grid>)
      }


      <Grid size={12} sx={{px: 1}}>
         <Box
      sx={{
        backgroundColor: "#BBDEFB", 
        borderRadius: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 20px",
        width: "100%",
      }}
    >
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">
          Total facturación
        </Typography>
        <Typography variant="body2">{data.periodo} ({mesActualNombre})</Typography>
      </Box>
      <Typography variant="h6" fontWeight="bold">
        {formatCurrency(data.valor_mensual_a_facturar_con_iva - data.d_total_n_menos_1 - data.d_total_n_menos_2 - originalDescuento + originalAbono)}

      </Typography>
    </Box>
      </Grid>
      </Grid>

          
            { includeRol([ROL_OP_ADMIN, ROL_ADMIN]) ?
        (<Grid container spacing={1} justifyContent="space-between" sx={{ pt: 1, px: 1 }}>
          { false ?
            (<Grid size={6}>
            <PageButtonWhite
              loading={data.estado_validacion !== "Pendiente" || !data.diferencia || true}
              width="100%"
              pad="0.5rem 1rem"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/apelacion/" + data.periodo)
              }}
            >
              Hacer apelación
            </PageButtonWhite>
          </Grid>) : null}

          <Grid size={12}>
            <PageButtonBlack
              loading={data.estado_validacion !== "Pendiente" || loading}
              width="100%"
              pad="0.5rem 1rem"
              onClick={(e) => {
                e.stopPropagation();
                handleOpen();
              }}
            >
              Aceptar prefactura
            </PageButtonBlack>
          </Grid>
        </Grid>)

         : null }

{includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_ADMIN]) && (
 <Grid container spacing={1} justifyContent="space-between" sx={{ pt: 1, px: 1 }}>
    <Grid size={type ? 6 : 12} >
      <PageButtonWhite
        loading={data.estado_validacion !== "En Apelación"}
        width="100%"
        pad="0.5rem 1rem"
        onClick={(e) => {
          e.stopPropagation();
          navigate("/apelacion_validacion/" + data.id);
        }}
      >
        Revisar apelación
      </PageButtonWhite>
    </Grid>

    {type && (
      <Grid size={6}>
        <PageButtonBlack
          loading={
            data.estado_validacion === "En Apelación" ||
            data.estado_validacion === "Pendiente" ||
            data.estado_validacion === "Finalizado" ||
            data.codigo !== "-"
          }
          width="100%"
          pad="0.5rem 1rem"
          onClick={(e) => {
            e.stopPropagation();
            getPreCode(data.id, data.periodo);
          }}
        >
          Generar código
        </PageButtonBlack>
      </Grid>
    )}
      </Grid>

)}
<Grid container spacing={1} justifyContent="space-between">
       <Grid size={12}>
        <Box sx={{ p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 80, borderRadius: 2 }}>
          <Stack spacing={1} sx={{ textAlign: 'center' }}>
            <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 1 }}>
              <b>Código de aprobación prefactura: {data.codigo ?? '-'}</b>
            </Typography>
            <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 2 }}>
              Validador: {data.nombre_validador ?? '-'}
            </Typography>
          </Stack>
        </Box>
      </Grid>

      
    </Grid>

          <ModalStandardCancel
        open={open}
        error={true}
        icon={<RequestQuoteOutlinedIcon sx={{ fontSize: 55 }}/>}
        title="Aceptar prefactura"
        msg="Usted está aceptando los totales a facturar correspondiente al mes actual (mayo) con los datos monitoreados en abril y con los descuentos pertenecientes a febrero y marzo"
        qst="En el caso de no estar de acuerdo con los totales o tener dudas con respecto a estos valores presione cancelar o cierre (X) esta ventana para luego realizar una apelación."
        btnText="OK, aceptar la prefactura"
        onClick={acceptPrefacture}
        onClose={handleClose}
      />

    </>
  );
};

export default DescuentoPeriodoCardV2;
